import React, { useRef } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ChartDownloader from './chartDownloader';
import MDTypography from 'components/MDTypography';
import { CircularProgress } from '@mui/material';

ChartJS.register(ArcElement, Tooltip, Legend);

export const options = {
    plugins: {
        plugins: {
            datalabels: {
                color: '#36A2EB'
            }
        }
    },
};

export function PichartReport({ label, data, loading }) {
    const chartRef = useRef(null);
    const empty = data?.labels.length > 0

    return (
        <div style={{ height: loading ? "300" : !empty ? '100px' : '300px' }}>
            <ChartDownloader download={empty} reff={chartRef} label={label} />
            {
                loading ? <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} >
                    <CircularProgress />
                </div> :
                    empty ?
                        <Pie ref={chartRef} data={data} options={options} />
                        :
                        <MDTypography variant="h6" color="dark" style={{ marginTop: "5px" }}>
                            Sem dados no período seleccionado
                        </MDTypography>
            }
        </div>
    );
}
